(function vxCartRuntime(){
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function count(n){ var a = document.querySelector(".st-cart"); if (!a) return; var i = a.querySelector("i"); if (!n){ if (i) i.remove(); return; } if (!i){ i = document.createElement("i"); a.appendChild(i); } i.textContent = n; }
  function toast(name, ok, err){
    var d = document.getElementById("vx-toast");
    if (!d){ d = document.createElement("div"); d.id = "vx-toast"; d.className = "vx-toast"; d.setAttribute("role", "status"); d.setAttribute("aria-live", "polite"); document.body.appendChild(d); }
    d.innerHTML = "";
    var b = document.createElement("b"); b.textContent = ok ? "Añadido al carrito" : "No se pudo añadir"; d.appendChild(b);
    var sp = document.createElement("span"); sp.textContent = ok ? (name || "") : (err || "Inténtalo de nuevo en unos segundos."); d.appendChild(sp);
    if (ok){
      var row = document.createElement("div"); row.className = "vx-toast-r";
      var go = document.createElement("a"); go.href = base + "cart"; go.className = "vx-toast-go"; go.textContent = "Ver carrito y pagar"; row.appendChild(go);
      var k = document.createElement("button"); k.type = "button"; k.className = "vx-toast-k"; k.textContent = "Seguir comprando"; k.onclick = function(){ d.classList.remove("on"); }; row.appendChild(k);
      d.appendChild(row);
    }
    d.classList.add("on"); clearTimeout(d._t); d._t = setTimeout(function(){ d.classList.remove("on"); }, ok ? 7000 : 4500);
  }
  function add(id, q, btn, name){
    if (!id) return toast("", false, "Este producto no está disponible ahora mismo.");
    var old = btn.innerHTML; btn.disabled = true; btn.setAttribute("aria-busy", "true");
    fetch(base + "cart/add.js", {method:"POST", headers:{"Content-Type":"application/json", "Accept":"application/json"}, body:JSON.stringify({items:[{id:Number(id), quantity:Number(q) || 1}]})})
      .then(function(r){ if (!r.ok) return r.json().then(function(j){ throw new Error(j && (j.description || j.message) || "error"); }); return fetch(base + "cart.js", {headers:{"Accept":"application/json"}}); })
      .then(function(r){ return r.json(); })
      .then(function(c){ count(c && c.item_count); toast(name, true); })
      .catch(function(e){ toast("", false, e && e.message && e.message !== "error" ? e.message : ""); })
      .then(function(){ btn.disabled = false; btn.removeAttribute("aria-busy"); btn.innerHTML = old; });
  }
  document.addEventListener("click", function(e){
    var t = e.target, x; if (!t || !t.closest) return;
    if ((x = t.closest("[data-vx-addcart]"))){
      e.preventDefault();
      var h = x.closest("[data-vx-hero]"), v = h && h.querySelector("[data-vx-variant]"), q = h && h.querySelector("[data-vx-qty]"), n = h && h.querySelector("h1");
      add(v && v.value, q && q.value, x, n ? n.textContent.trim() : "");
      return;
    }
    if ((x = t.closest("[data-vx-quick]"))){ e.preventDefault(); add(x.getAttribute("data-vx-quick"), 1, x, x.getAttribute("data-name") || ""); }
  });
})();